import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './pages/authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { TestComponent } from './pages/test/test.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { CoursesComponent } from './pages/courses/courses/courses.component';
import { AddExamComponent } from './pages/courses/add-exam/add-exam.component';
import { AddCourseComponent } from './pages/courses/add-course/add-course.component';
import { CourseDashboardComponent } from './pages/courses/course-dashboard/course-dashboard.component';
import { ViewCourseComponent } from './pages/courses/view-course/view-course.component';
import { ImportantNoticeComponent } from './pages/important-notice/important-notice.component';
// import { CertificateManagementComponent } from './pages/certificate-management/certificate-management.component';
import { ForumManagementComponent } from './pages/forum/forum-management/forum-management.component';
import { StaffSurveyDashboardComponent } from './pages/staff-survey/staff-survey-dashboard/staff-survey-dashboard.component';
import { DocumentDashboardComponent } from './pages/documents/document-dashboard/document-dashboard.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { SubSectionNewComponent } from './pages/individual/sub-section-new/sub-section-new.component';
import { CoursePlaylistComponent } from './pages/course-playlist/course-playlist/course-playlist.component';
import { FeatureComponent } from './pages/feature/feature.component';
import { CertificateManagementComponent } from './pages/certificate/certificate-management/certificate-management.component';
import { ViewCoursePreviewComponent } from './pages/courses/view-course-preview/view-course-preview.component';
import { RoleGuard } from './core/guard/role.guard';
import { UserAccountComponent } from './pages/authentication/user-account/user-account.component';
import { RecruitmentPortalComponent } from './pages/recruitment-portal/recruitment-portal.component';
import { UrlBasedGuardGuard } from './core/guard/url-based-guard.guard';
import { AdminGuardGuard } from './core/guard/admin-guard.guard';
import { AdminGuard } from './core/guard/admin.guard';
import { JobSchedulingComponent } from './pages/recruitment/job-scheduling/job-scheduling.component';
import { OrderPurchasedComponent } from './pages/order-purchased/order-purchased.component';

import { NotificationComponent } from './pages/notification/notification.component';
import { SettingsComponent } from './pages/company-settings/settings/settings.component';
import { CommentsComponent } from './pages/employees/comments/comments.component';
import { ChatComponent } from './pages/chat/chat.component';
import { IframeTimeClockCardComponent } from './pages/recruitment/time-clock-card/iframe-time-clock-card/iframe-time-clock-card.component';
import { TimeClockDashboardComponent } from './pages/recruitment/time-clock-card/time-clock-dashboard/time-clock-dashboard.component';
import { MainClockCardLobbyComponent } from './pages/recruitment/time-clock-card/main-clock-card-lobby/main-clock-card-lobby.component';
import { JobCalendarComponent } from './pages/recruitment/job-calendar/job-calendar.component';
// import { ChatComponent } from './apps/chat/chat.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      { path: 'course-dashboard', component: CourseDashboardComponent },
      {
        path: "test",
        component: TestComponent,
      },
      {
        path: 'apps',
        loadChildren: () => import('./apps/apps.module').then((m) => m.AppsModule),
      },
      {
        path: 'icons',
        loadChildren: () => import('./icons/icons.module').then((m) => m.IconsModule),
      },
      {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [RoleGuard],
        data: { menuName: 'user_management' }
      },
      {
        path: 'view-course',
        component: ViewCourseComponent,
        canActivate: [RoleGuard],
        data: { menuName: 'course_builder' }
      },
      {
        path: 'important-notice',
        component: ImportantNoticeComponent,
        canActivate: [RoleGuard],

        data: { menuName: 'notice' }
      },
      {
        path: 'certificate-management',
        component: CertificateManagementComponent,
        canActivate: [RoleGuard],
        data: { menuName: 'certificate' }
      },
      {
        path: 'forum-management',
        // canActivateChild: [AuthGuard],
        component: ForumManagementComponent,
        canActivate: [RoleGuard],
        data: { menuName: 'forum' },
      },
      {
        path: 'staff-survey',
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/staff-survey/staff-survey.module').then((m) => m.StaffSurveyModule),
        canActivate: [RoleGuard],
        data: { menuName: 'staff_survey' },
      },
      {
        path: 'course-playlist',
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/course-playlist/course-playlist.module').then((m) => m.CoursePlaylistModule),
        canActivate: [RoleGuard],
        data: { menuName: 'course_playlist' },
      },
      {
        path: "course",
        canActivateChild: [AuthGuard],
        canActivate: [RoleGuard],
        loadChildren: () => import('./pages/courses/courses/courses.module').then((m) => m.CoursesModule),       
        data: { menuName: 'course_builder' },
      },
      {
        path: "package",
        canActivate: [RoleGuard],
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/package-management/package-management.module').then((m) => m.PackageManagementModule),
        data: { menuName: 'manage_package' },
      },
      {
        path: "document",
        canActivate: [RoleGuard],
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/documents/documents.module').then((m) => m.DocumentsModule),
        data: { menuName: 'upload_document' },
      },
      {
        path: "department",
        canActivate: [RoleGuard],
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/department/department.module').then((m) => m.DepartmentModule),
        data: { menuName: 'dept_management' },
      },
      {
        path: "individual",
        canActivate: [RoleGuard],
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/individual/individual.module').then((m) => m.IndividualModule),
        data: { menuName: 'individual' },
      },
      {
        path: "manager",
        canActivate: [RoleGuard],
        // canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/manager/manager.module').then((m) => m.ManagerModule),
        data: { menuName: 'manager' },
      },
      {
        path: "feature",
        component: FeatureComponent,
      },
      {
        path: "account",
        component: UserAccountComponent,
        canActivateChild: [AuthGuard],
      },
      { path: 'recruitment', component:RecruitmentPortalComponent },

      {
        path:"user",
        loadChildren:()=>import('./pages/user-management/user-management.module').then((m)=>m.UserManagementModule),
      },
      {
        path:"settings",
        component: SettingsComponent,
        canActivateChild: [AuthGuard],
      },
      {
        path:"notifications",
        component: NotificationComponent,
        canActivateChild: [AuthGuard],
      },
      {
        path:"comments",
        component:CommentsComponent
      },
      {
        path: 'chat',
        canActivate: [AuthGuard],
        component:ChatComponent
        // loadChildren: () => import('./pages/courses/courses/courses.module').then((m) => m.CoursesModule),
      },
      { path: 'rec',  loadChildren: () => import('./pages/recruitment/recruitment.module').then((m) => m.RecruitmentModule),},
    ],
  },
 
  {
    path: "order-purchased",
    component: OrderPurchasedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () => import('./pages/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'sub-section-new',
    component: SubSectionNewComponent,
    data: { requiredPermissions: ['individual'] },
    canActivate: [UrlBasedGuardGuard],
  },
  {
    path: 'courses',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/courses/courses/courses.module').then((m) => m.CoursesModule),
  },


  // { path: 'cdashboard', component: CourseDashboardComponent,  canActivate: [AdminGuard], }, //change by ankush
  { path: 'cdashboard', component: CourseDashboardComponent },
  { path: "doc-dashboard", component: DocumentDashboardComponent },
  { path: "admin-cert", component: CertificateManagementComponent, },
  { path: "admin-course-preview", component: ViewCoursePreviewComponent, },
  // {path:"media",loadChildren: () => import('./maps/maps.module').then((m) => m.MapsModule),},
   {path:"iframe-main-clock",component:MainClockCardLobbyComponent},
   {path:"iframe-time-clock",component:TimeClockDashboardComponent},
   {path:"iframe-job-scheduling",component:JobCalendarComponent},

   {
    path: 'iframe',
    canActivate: [AdminGuard],
    loadChildren: () => import('./pages/iframe/iframe/iframe.module').then((m) => m.IframeModule),
  },
  { path: '**', component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
